<template>
<div>
	<div class="btn-toolbar pull-right visible-lg visible-md visible-sm" role="toolbar">
		<div class="btn-group form-inline" role="group" aria-label="...">
			<div class="input-group">
				<span class="input-group-addon">
					<input type="checkbox" v-model="filter.allowDate">
				</span>
				<input type="text" v-model="filter.date" class="form-control daterange" :class="{ disabled: !filter.allowDate }" id="daterange" placeholder="Rango de fecha">
			</div>
		</div>

		<div class="btn-group form-inline">
			<input @keyup="keyUpdoFilter($event)" v-model="filter.text" class="form-control" placeholder="Buscar...">
		</div>

		<div class="btn-group" role="group" aria-label="...">
			<button
				ref="btnfilter"
				@click="doFilter()"
				class="btn btn-default">
				<i class="fa fa-search" aria-hidden="true"></i>
			</button>
			<button
				title="Recargar"
				ref="btnreset"
				@click="reset()"
				class="btn btn-default">
				<i class="fa fa-refresh"></i>
			</button>

			<button @click="$emit('openMap')" class="btn btn-default" title="Mapa">
				<i class="fa fa-map" aria-hidden="true"></i>
			</button>

			<button @click="filterUser()" type="button" class="btn btn-default" title="Mis proyectos" :class="{ 'active' : filter.author_id }">
				<i class="fa fa-user-circle-o" aria-hidden="true"></i>
			</button>
			<template v-if="statuses">
				<template v-if="statuses.length">
					<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li
							v-for="status in statuses"
							@click="filterStatus(status)"
							:class="{ 'active' : status.id == filter.project_status_id }">
							<a href="#" class="active">
								<template v-if="status.lang">
									{{ status.lang.name }}
								</template>
								<template v-else>
									{{ status.name }}
								</template>
							</a>
						</li>
					</ul>
				</template>
			</template>
		</div>
	</div>
	<div class="visble-xs hidden-lg hidden-md hidden-sm">
		<div id="filter" ref="filter" class="collapse">
			<div class="row">
				<div class="col-md-12 m-b-5">
					<div class="input-group">
						<span class="input-group-addon">
							<input type="checkbox" v-model="filter.allowDate">
						</span>
						<input type="text" v-model="filter.date" class="form-control daterange" :class="{ disabled: !filter.allowDate }" id="daterange" placeholder="Rango de fecha">
						<span class="input-group-btn">
							<button
								ref="btnfilter"
								@click="doFilter()"
								class="btn btn-default">
								<i class="fa fa-search" aria-hidden="true"></i>
							</button>
						</span>
					</div>
				</div>
				<div class="col-md-12  m-b-5">
					<div class="input-group">
						<input @keyup="keyUpdoFilter($event)" v-model="filter.text" type="text" class="form-control" placeholder="Buscar...">
						<span class="input-group-btn">
							<button
								title="Recargar"
								ref="btnreset"
								@click="reset()"
								class="btn btn-default">
								<i class="fa fa-refresh"></i>
							</button>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'statuses'],
		data () {
			return {
				filter: {
					allowDate: false,
					status: null,
					date: null,
					text: null,
					project_status_id: null,
					author_id: null,
				}
			}
		},
		watch: {
			'filter.allowDate'() {
				this.initDate()
			}
		},
		created() {
			//this.init()
		},
		methods: {
			init() {
			},
			collapse() {
				$(this.$refs.filter).collapse("toggle")
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				if(!this.filter.allowDate) {
					this.filter.date = null
				}
				this.$events.fire('filterSet', this.filter)
			},
			clearData() {
				this.filter.allowDate = false
				this.filter.status = null
				this.filter.date = null
				this.filter.text = null
				this.filter.project_status_id = null
				this.filter.author_id = null
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset', this.filter)
			},
			filterUser() {
				if(this.filter.author_id) {
					this.filter.author_id = null
				} else {
					this.filter.author_id = this.user.id
				}
				this.doFilter()
			},
			filterStatus(status) {
				this.filter.project_status_id = status.id
				this.doFilter()
			},
			initDate() {
				var that = this
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('.daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				}).on('hide.daterangepicker', function(e, picker) {
					that.filter.date = moment(picker.startDate).format('DD/MM/YY') + ' - ' +moment(picker.endDate).format('DD/MM/YY')
				})
				this.filter.date = startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/FilterBar.vue